// src/locales/index.js
// VEGA ROBOTICS - Configuração de Idiomas

import pt from './pt';
import en from './en';
import es from './es';

// ============================================================
// IDIOMAS DISPONÍVEIS
// ============================================================
export const languages = [
  {
    code: 'pt',
    name: 'Português',
    nativeName: 'Português',
    flag: '🇧🇷',
    locale: 'pt-BR',
  },
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇺🇸',
    locale: 'en-US',
  },
  {
    code: 'es',
    name: 'Español',
    nativeName: 'Español',
    flag: '🇪🇸',
    locale: 'es-ES',
  },
];

// ============================================================
// IDIOMA PADRÃO
// ============================================================
export const defaultLanguage = 'pt';

// ============================================================
// OBJETO DE TRADUÇÕES
// ============================================================
export const translations = {
  pt,
  en,
  es,
};

// ============================================================
// EXPORT DEFAULT
// ============================================================
export default {
  languages,
  defaultLanguage,
  translations,
};
